exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settings__item[data-v-c8be1670] {\n  margin-bottom: 24px;\n}\n.settings__item-header[data-v-c8be1670] {\n  margin-bottom: 16px;\n}\n.settings__logout-icon[data-v-c8be1670] {\n  margin-bottom: 24px;\n}\n.settings__logout-text[data-v-c8be1670] {\n  margin: 16px 0;\n  color: #578AD6;\n}\n.settings .md-list.md-theme-default[data-v-c8be1670] {\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n}\n.settings-dialog__content[data-v-c8be1670] {\n  margin: 24px 0;\n}\n.settings-dialog__description[data-v-c8be1670] {\n  margin: 16px 0;\n  color: #578AD6;\n}\n.settings[data-v-c8be1670] {\n  padding-top: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c8be1670","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/settings/security/Settings.Security.vue
// module id = LsNd
// module chunks = 1